// extracted by mini-css-extract-plugin
export default {"rotateIcon":"styles_rotateIcon__atlp6","headerShadow":"styles_headerShadow__lxB3t"};